import { ApiEffectivenessRule, ApiProject } from "@incendium/api";
import { effectivenessRuleService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetchEffectivenessRules = async (project: ApiProject) => {
  const effectivenessRules = await effectivenessRuleService.effectivenessRuleServiceListRules({
    projectId: project.id as number,
  });
  return effectivenessRules.results || [];
};

export const useEffectivenessRules = () => {
  const { state, setState } = useProjectSharedState<ApiEffectivenessRule[]>(
    "effectivenessRules",
    [],
    fetchEffectivenessRules
  );

  return {
    effectivenessRules: state,
    setEffectivenessRules: setState,
  };
};
